import axios from "axios";
import { API_URL } from "configs/apiUrls";
import {
  showCommonLoader,
  hideCommonLoader,
  showGeneralError,
  tokenError,
} from "actions/commonActions";
import {
  defaultQuarterlyReportFilename,
  getFilenameFromContentDisposition,
  parseBlobErrorMessage,
  triggerBlobDownload,
} from "../utils/quarterlyReportDownload";

export const downloadQuarterlyReport = ({ object_viewed_id, quarter, year }) => {
  return async (dispatch) => {
    const token = localStorage.getItem("token");

    if (!object_viewed_id) {
      dispatch(
        showGeneralError(
          "Unable to download report. Page permissions are missing."
        )
      );
      return;
    }

    if (!quarter) {
      dispatch(showGeneralError("Please choose a quarter."));
      return;
    }

    const reportYear = year || String(new Date().getFullYear());

    dispatch(showCommonLoader("Downloading report..."));

    try {
      const response = await axios.get(`${API_URL}quarterly-reports/download`, {
        params: {
          object_viewed_id,
          quarter,
          year: reportYear,
        },
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/octet-stream, application/json",
        },
        responseType: "blob",
      });

      const blob = response.data;

      if (blob?.type?.includes("application/json")) {
        const message = await parseBlobErrorMessage(blob);
        dispatch(showGeneralError(message));
        return;
      }

      const filename =
        getFilenameFromContentDisposition(
          response.headers?.["content-disposition"]
        ) || defaultQuarterlyReportFilename(quarter, reportYear);

      triggerBlobDownload(blob, filename);
    } catch (error) {
      if (error.response?.status === 401) {
        const message =
          error.response?.data?.error?.toString?.() || "Session expired";
        dispatch(tokenError(message));
        return;
      }

      if (error.response?.data instanceof Blob) {
        const message = await parseBlobErrorMessage(error.response.data);
        dispatch(showGeneralError(message));
        return;
      }

      const message =
        error.response?.data?.message ||
        error.response?.data?.error ||
        error.message ||
        "Failed to download report.";
      dispatch(showGeneralError(String(message)));
    } finally {
      dispatch(hideCommonLoader());
    }
  };
};
